import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import Tooltip from '@lib/components/Tooltip/Tooltip';
import { ModalMode } from '@lib/components/Modal/enums';
import { FetchIdsResponse } from '@lib/utils/getAllTableItemsIds';
import IconSurface from '@lib/components/IconSurface/IconSurface';
import { Colors } from '@lib/enums/colors';
import TaskCompletionDetailsContent from './TaskCompletionDetailsContent';
import styles from './TaskCompletionDetails.module.scss';

type Props = {
  completionId: string | null;
  onChangeCompletionId: (id: string) => void;
  onClose: () => void;
  fetchIds?: () => Promise<FetchIdsResponse<unknown>>;
  isFilterApplied?: boolean;
};

export default function TaskCompletionDetails(props: Props) {
  const {
    completionId,
    onClose,
    onChangeCompletionId,
    fetchIds,
    isFilterApplied,
  } = props;
  const { t } = useTranslation();
  const renderAfterCaption = (
    <Tooltip body={t('you-currently-see-filtered-result')}>
      <IconSurface
        icon="filter_alt"
        symbolsOutlined
        color={Colors.Blue}
        size="sm"
      />
    </Tooltip>
  );
  return (
    <Modal
      isOpen={!!completionId}
      onClose={onClose}
      caption={t('completion-details')}
      renderAfterCaption={isFilterApplied ? renderAfterCaption : undefined}
      mode={ModalMode.FullScreen}
      modalContentClassName={styles.modalContentClassName}
    >
      <TaskCompletionDetailsContent
        completionId={completionId}
        onChangeCompletionId={onChangeCompletionId}
        fetchIds={fetchIds}
      />
    </Modal>
  );
}
